import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f8d3b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增合同")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("批量更新管理人")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("打印")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("附件")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("核对")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("关闭预览")
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "contractContent"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("确认无误")
const _hoisted_20 = {
  key: 0,
  class: "contractContent"
}
const _hoisted_21 = { class: "printContent" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("打印")
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("最终确认无误")

import { ref, nextTick, reactive, computed, onBeforeMount, onMounted, onActivated } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix, {cpyCfig, orgCfig, userCfig} from '@/global_mixin/tableMixin'
import { useRoute, useRouter } from 'vue-router'
import { formatNumber, formatTime, exportHandle } from '@/utils/index'
import ContractTemplate from './contractTemplate/ContractTemplate.vue'
import ServiceTemplate from './contractTemplate/ServiceTemplate.vue'
import InternshipTemplate from './contractTemplate/InternshipTemplate.vue'
import ExceptionList from '@/views/ViewsComponents/humanMaintain/ExceptionList.vue'
import { useStore } from 'vuex'
import { signTimesMap, categoryMap } from '@/views/typeMapping/HumanReousces'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    convenientParams: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  convenientParams?: object
}

const {
  'POST/labor_contracts/list': fetchList,
  // 删除
  'DELETE/labor_contracts/{id}': delContractApi,
  // 劳务合同_设置为作废状态
  'PATCH/labor_contracts/home_page/waster': wasterApi,
  // 新增-劳动合同信息
  'POST/labor_contracts': labor_contractsAddApi,
  // 更新-劳动合同信息
  'PATCH/labor_contracts': labor_contractsModifyApi,
  // 上传-劳动合同文件
  'POST/labor_contracts/upload': uploadApi,
  // 获取劳动合同附件列表
  'GET/labor_contracts/{id}': labor_contractsFileListApi,
  // 删除劳动合同文件
  'DELETE/labor_contracts/delete_file': delete_fileApi,
  // 用户下拉列表
  'GET/users/list': usersListApi,
  // 获取所有公司
  'GET/company': companyApi,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 获取审批状态
  'GET/labor_contracts/drop_list/approval_status': approval_statusApi,
  // 预览上传合同
  'GET/labor_contracts/home_page/preview': previewApi,
  // 审批通过
  'POST/labor_contracts/home_page/approving': approvingApi,
  // 获取员工基本信息
  'GET/users/{id}/profile': getProfileApi,
  // 合同_生成合同编号
  'GET/labor_contracts/generate/contract_no': contract_noApi,
  // 批量修改合同管理员
  'PATCH/labor_contracts/update_manger': update_mangerApi,
  // 获取当前用户所在团队团长
  'GET/organizations/get_owners': get_ownersApi,
  // 所有办公所在地
  'GET/house_leases': fullOfficeApi,
  // 根据id获取合同
  'GET/labor_contracts/get/{id}': getContractsInfoApi,
  // 劳务合同档案_是否可签署合同
  'POST/labor_contracts/home_page/can_be_signed': can_be_signedApi,
  //  劳务合同_下载
  'POST/labor_contracts/download': downloadApi,
} = Api

const searchForm = ref()
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const route = useRoute()
const store = useStore()
let userList: any = ref([])
let companyList: any = ref([])
let orgList: any = ref([])
let statusMap: any = reactive({})
let selectionRows: any = ref([])
let officeList: any = ref([])

onBeforeMount(() => {
  usersListApi().then((rep) => {
    rep.map((u: any) => u.label = `${u.realName}(${u.alias})`)
    userList.value = rep
  })
  companyApi().then((rep) => {
    companyList.value = rep
  })
  organizationsApi().then((rep) => {
    orgList.value = rep
  })
  // 获取合同状态类型
  approval_statusApi().then((rep: any) => {
    Object.assign(statusMap, rep)
  })
  // 获取所有办公所在地
  fullOfficeApi().then((rep: any) => {
    officeList.value = rep
  })
})

onMounted(() => {
  // 上传附件
  if(props.convenientParams?.type === '1'){
    // 获取已上传的附件
    MI_identify.value = true
    getContractsInfoApi({id: props.convenientParams.id}).then((rep: any) => {
      viewContractHandle({id: props.convenientParams.id, fileList: rep.fileList})
    }).finally(() => {
      MI_identify.value = false
    })
    
  }
  // 校对
  if(props.convenientParams?.type === '2'){
    // 获取系统合同信息
    MI_identify.value = true
    getContractsInfoApi({id: props.convenientParams.id}).then((rep: any) => {
      Object.assign(checkPreviewObj, rep)
      currentContracts.value = rep
      // 获取签署上传的合同
      isShowCheck.value = true
      previewRealFile()

      // return previewApi({id: props.convenientParams.id})
    }).finally(() => {
      MI_identify.value = false
    })
    /* .then((repUrl: any) => {
      checkPreveiwUrl.value = repUrl.url
      isShowCheck.value = true
    }).finally(() => {
      MI_identify.value = false
    }) */
  }
  // 新增合同
  signContractHandle()
})

onActivated(() => {
  signContractHandle()
})

// 判断合同类型函数
const signContractHandle = () => {
  // 新增合同
  if(route.query?.type === '3'){
    addHandle()
    createObj.userId = Number(route.query.id)
    employeeChange(Number(route.query.id))
  }
  // 续签
  if(route.query?.type === '4') {
    // 获取历史合同数据
    fetchList({
      userId: Number(route.query.id),
      page: 1,
      size: 100,
    }).then((rep) => {
      addHandle()
      Object.assign(createObj, rep[0])
      createObj.userId = Number(route.query.id)
      employeeChange(Number(route.query.id))
    })
  }
}

const exceptionAddHandle = (userId: number) => {
  addHandle()
  createObj.userId = Number(userId)
  employeeChange(Number(userId))
}

const exceptionRenewHandle = () => {
  // 获取历史合同数据
  fetchList({
    userId: Number(route.query.id),
    page: 1,
    size: 100,
  }).then((rep) => {
    addHandle()
    Object.assign(createObj, rep[0])
    createObj.userId = Number(route.query.id)
    employeeChange(Number(route.query.id))
  })
}

const searchConfig = ref([
  {
    label: '姓名',
    value: '',
    upKey: 'key',
  },
  {
    label: '合同编号',
    value: '',
    upKey: 'no',
  },
  orgCfig(),
  {
    type: 'SELECT',
    selectType: 'GROUP',
    label: '公司',
    value: '',
    upKey: 'companyId',
    options: store.getters.sysCompany,
    props: {clearable: true, placeholder: '请选择公司',},
    seleProps: {label: 'name', valueName: 'id'}
  },

])

// 展示模板
const isShowPreviewTemplate = ref<boolean>(false)



const leadersOption: any = ref([])
const createdEle = ref()
const createObj: any = reactive({
  userId: '',
  no: '',
  companyId: '',
  orgId: '',
  category: '',
  signTimes: '',
  startDate: '',
  endDate: '',
  probationTime: 0,
  leaderId: '',
  rewardId: 49702,
  operator: store.getters.userId,
  baseSalary: 0,
  jobAllowance: 0,
  probationPostAllowance: 0,
  postAllowance: 0,
  otherAllowance: 0,
  companyAllowance: 0,
  probationPerformanceBonus: 0,
  performanceBonus: 0,
  perfectAttendanceAward: 0,
  probationSalary: 0,
  regularSalary: 0,
  officeSpace: '',
  note: '',
  otherAgreement: '',
})
const employeeChange = (val: number) => {
  isAddPanelLoad.value = true
  // 获取团长
  get_ownersApi({userId: val}).then((ownerArr: any) => {
    let ownerIds = ownerArr.map((e: any) => e.ownerId)
    // 获取团长
    leadersOption.value = userList.value.reduce((arr: any, user: any) => {
      if(ownerIds.includes(user.userId)){
        arr.push(user)
      }
      return arr
    }, [])

    if(ownerArr.length === 1) {
      createObj.leaderId = ownerArr[0]?.ownerId || ''
    }
  })
  // 获取员工基本信息
  return getProfileApi({id: val}).then((rep: any) => {
    let { companyId, orgId, leaseName, staffType } = rep
    let category = 'FullTime'
    switch (staffType) {
      case '兼职':
        category = 'PartTime'
        break;
      case '试用期':
        category = 'FullTime'
        break;
      case '转正':
        category = 'FullTime'
        break;
      case '实习生':
        category = 'Internship'
        break;
      default:
        category = 'FullTime'
        break;
    }

    Object.assign(
      createObj, 
      { companyId, orgId: orgId[0], officeSpace: leaseName, category  }
    )
    // 生成合同编号
    return contract_noApi({category})
  }).then((rep) => {
    createObj.no = rep.no
  }).finally(() => {
    isAddPanelLoad.value = false
  })

}
const categoryChange = (type: string) => {
  isAddPanelLoad.value = true
  contract_noApi({category: type}).then((rep) => {
    createObj.no = rep.no
  }).finally(() => {
    isAddPanelLoad.value = false
  })
}

const showAddPreview = async () => {
  // 再次计算工资合计
  computedSalaryTotal()
  // 判断是否提醒永久合同
  if(createObj.signTimes === 'Forever'){
    await ElMessageBox.alert('请注意,合同签订次数为永久', '提示', {confirmButtonText: '确定'});
  }

  // 判断合同是否可以签署
  can_be_signedApi({
    userId: createObj.userId,
    category: createObj.category,
    signTimes: createObj.signTimes,
  }).then(({canBeSigned}: {canBeSigned: boolean}) => {
    if(canBeSigned) return ElMessageBox.alert('请注意,同一类型的合同已存在', '提示', {confirmButtonText: '确定'});
    // 可以签署
    return true
  }).then(() => {
    // 获取公司名称, 注册地址
    let com = companyList.value.find(e => e.id === createObj.companyId)
    previewContractObj.companyName = com?.name
    previewContractObj.registeredAddress = com?.registeredAddress
    // previewContractObj.companyName = companyList.value.find(e => e.id === createObj.companyId)?.name
    // 确认后先合同预览
    Object.assign(previewContractObj, createObj)
    isShowPreviewTemplate.value = true
  }).catch(() => {})
}

// 添加
const addContractEle = ref()
const isAddPanelLoad = ref<boolean>(false)
const isEditContract = ref<boolean>(false)
const isShowAddition = ref<boolean>(false)
const previewContractObj: any = reactive({})


const isFirstContract = computed(() => {  
  return addContractEle.value?.dataObj.signTimes !== 'First'
})
const isShowProbation = computed(() => {
  return addContractEle.value?.dataObj.signTimes === 'First'
})
const addHandle = () => {
  isEditContract.value = false
  isShowAddition.value = true
}



const computedSalaryTotal = () => {
  // 自动计算转正薪资
  createObj.regularSalary = createObj.baseSalary + createObj.jobAllowance + createObj.postAllowance + createObj.otherAllowance + createObj.companyAllowance + createObj.performanceBonus + createObj.perfectAttendanceAward
  // 非试首次签订,试用期工资为0
  if(createObj.signTimes !== 'First') {
    createObj.probationSalary = 0
    return
  }
  // 自动计算试用期薪资
  createObj.probationSalary = createObj.baseSalary + createObj.jobAllowance + createObj.probationPostAllowance + createObj.otherAllowance + createObj.companyAllowance + createObj.probationPerformanceBonus + createObj.perfectAttendanceAward
  return
  const obj = addContractEle.value.dataObj
  // 自动计算转正薪资
  obj.regularSalary = obj.baseSalary + obj.jobAllowance + obj.postAllowance + obj.otherAllowance + obj.companyAllowance + obj.performanceBonus + obj.perfectAttendanceAward
  if(obj.signTimes !== 'First') {
    obj.probationSalary = 0
    return;
  }
  // 自动计算试用期薪资
  obj.probationSalary = obj.baseSalary + obj.jobAllowance + obj.probationPostAllowance + obj.otherAllowance + obj.companyAllowance + obj.probationPerformanceBonus + obj.perfectAttendanceAward
}
// 批量添加管理人
const isShowUpdata = ref<boolean>(false)
const updataConfig = ref([
  userCfig({
    label: '管理人',
    upKey: 'mangerId',
    options: userList,
    rule: [{ required: true, message: '请选择管理人', trigger: 'change' }],
  })
])
const batchUpdataManager = () => {
  if(selectionRows.value.length === 0){
    ElMessage.warning('请至少选择一条合同数据')
    return
  }
  MI_modifyForm({}, updataConfig, isShowUpdata, async (params: any) => {
    await update_mangerApi({...params, ids: selectionRows.value.map((e: {id: number}) => e.id)})
    ElMessage.success('成功')
    isShowUpdata.value = false
    fetchData(MI_params)
  })
}
// 模板确认无误,提交保存
const templateEle = ref()
const addBtnLoading = ref<boolean>(false)
const submitAddContract = () => {
  const contractInfo = templateEle.value.confirmHandle()
  addBtnLoading.value = true
  labor_contractsAddApi(contractInfo).then((rep) => {
    ElMessage.success('新增成功')
    isShowAddition.value = false
    isShowPreviewTemplate.value = false
    fetchData(MI_params)
  }).finally(() => {
    addBtnLoading.value = false
  })
}

// 预览按钮(打印)
const isShowPrint = ref<boolean>(false)
const printPreviewObj: any = reactive({})
const showPreviewHandle = (row: any) => {
  Object.assign(printPreviewObj, row)
  isShowPrint.value = true
}

// 打印
const printHandle = () => {
  const element: any = document.getElementById('contractTemplate');
  let printWindow: any = window.open('', '  ');
  if(printPreviewObj.category === 'Internship'){
    // 实习合同样式
    printWindow.document.write(`
      <html><head><style>
      .printWaterMark { opacity: 0.1 !important; }
      p { margin: 0pt }
      li { margin-top: 0pt; margin-bottom: 0pt }

      .CommentText { text-align: left; widows: 0; orphans: 0; font-family: Calibri; font-size: 10.5pt }

      .Footer { text-align: left; widows: 0; orphans: 0; font-family: Calibri; font-size: 9pt }

      .Header { text-align: center; widows: 0; orphans: 0; border-bottom: 0.75pt solid #000000; padding-bottom: 1pt; font-family: Calibri; font-size: 9pt }

      .ListParagraph { text-indent: 21pt; text-align: justify; widows: 0; orphans: 0; font-family: Calibri; font-size: 10.5pt }

      .Revision { font-family: Calibri; font-size: 10.5pt }

      span.a { font-size: 9pt }

      span.a0 { font-size: 9pt }

      .awlist1 { list-style: none; counter-reset: awlistcounter2_0 }

      .awlist1>li:before { content: counter(awlistcounter2_0) '、'; counter-increment: awlistcounter2_0 }

      .awlist2 { list-style: none; counter-reset: awlistcounter3_0 }

      .awlist2>li:before { content: counter(awlistcounter3_0) '、'; counter-increment: awlistcounter3_0 }

      .awlist3 { list-style: none; counter-reset: awlistcounter4_0 }

      .awlist3>li:before { content: counter(awlistcounter4_0) '、'; counter-increment: awlistcounter4_0 }

      .awlist4 { list-style: none; counter-reset: awlistcounter5_0 }

      .awlist4>li:before { content: counter(awlistcounter5_0) '、'; counter-increment: awlistcounter5_0 }

      .awlist5 { list-style: none; counter-reset: awlistcounter6_0 }

      .awlist5>li:before { content: counter(awlistcounter6_0) '、'; counter-increment: awlistcounter6_0 }

      .awlist6 { list-style: none; counter-reset: awlistcounter7_0 }

      .awlist6>li:before { content: counter(awlistcounter7_0) '、'; counter-increment: awlistcounter7_0 }

      .awlist7 { list-style: none; counter-reset: awlistcounter8_0 }

      .awlist7>li:before { content: counter(awlistcounter8_0) '、'; counter-increment: awlistcounter8_0 }
      </style></head><body>`
    );
    printWindow.document.write(element.innerHTML);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
    return
  }
  printWindow.document.write('<html><head>');
  printWindow.document.write('<style>');
  printWindow.document.write('.NormalWeb { margin-top: 5pt; margin-bottom: 5pt; font-family: 宋体; font-size: 12pt }');
  printWindow.document.write('.printWaterMark { opacity: 0.1 !important; }');
  printWindow.document.write('.Footer { font-size: 9pt }');
  printWindow.document.write('li, table { margin-top: 0pt; margin-bottom: 0pt; }');
  printWindow.document.write('h1, h3, p { margin: 0pt; }');
  printWindow.document.write('h3 { margin-top: 14pt; margin-bottom: 14pt; page-break-inside: avoid; page-break-after: auto; font-family: 宋体; font-size: 13pt; font-weight: bold; color: #000000; }');
  printWindow.document.write('h1 { margin-top: 14pt; margin-bottom: 14pt; text-align: center; page-break-inside: avoid; page-break-after: auto; font-family: 宋体; font-size: 18pt; font-weight: bold; color: #000000;}');
  printWindow.document.write('#printable-content { border: 2px solid red; padding: 30px; }');
  printWindow.document.write('</style></head><body>');
  printWindow.document.write(element.innerHTML);
  printWindow.document.write('</body></html>');
  printWindow.document.close();
  printWindow.print();
}

// 不预览,直接打印
const directPrintHandle = (row: any) => {
  showPreviewHandle(row)
  /* nextTick(() => {
    printHandle()
    // isShowPrint.value = false
  }) */
  setTimeout(() => {
    printHandle()

  }, 2000)
}

// 核对
const checkHeight = window.innerHeight - 200
let isShowCheck = ref<boolean>(false);
let checkPreveiwUrl = ref<string>('');
const checkPreviewObj: any = reactive({})
const checkHandle = (row: any) => {
  Object.assign(checkPreviewObj, row)
  currentContracts.value = row
  // 获取签署上传的合同
  /* MI_identify.value = true
  previewApi({id: row.id}).then((rep: any) => {
    checkPreveiwUrl.value = rep.url
    isShowCheck.value = true
  }).finally(() => {
    MI_identify.value = false
  }) */
  isShowCheck.value = true
  previewRealFile()
}

const btnLoad = ref(false)
const submitConfirm = () => {
  btnLoad.value = true
  approvingApi({id: checkPreviewObj.id}, {contentType: 'formData'}).then(() => {
    ElMessage.success('校对完成')
    isShowCheck.value = false
    fetchData(MI_params)
  }).finally(() => {
    btnLoad.value = false
  })
}

// 修改
const modifyFg = ref<boolean>(false)
const modifyHandle = async (row: any) => {
  isEditContract.value = true
  isShowAddition.value = true

  employeeChange(row.userId as number).then(() => {
    createObj.officeSpace = row.officeSpace
  })
  // 编辑数据添加
  createObj.id = row.id
  for (let key in createObj) {
    createObj[key] = row[key]
  }
}

const submitEdit = () => {
  labor_contractsModifyApi(createObj).then(() => {
    ElMessage.success('更新成功')
    isShowAddition.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = (row: any) => { 
  ElMessageBox.confirm(
    `是否删除该合同:${row.no}?`,
    '提示',
    {
      confirmButtonText: '确认删除',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    MI_identify.value = true
    return delContractApi({id: row.id})
  }).then(() => {
    ElMessage.success('已删除')
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })
}

// 作废
const wasterHandle = (row: any) => {
  ElMessageBox.confirm(
    `是否作废该合同:${row.no}?`,
    '提示',
    {
      confirmButtonText: '确认作废',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    MI_identify.value = true
    return wasterApi({id: row.id}, {contentType: 'formData'})
  }).then(() => {
    ElMessage.success('已作废')
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })
}

// 查看附件
const isShowFile = ref<boolean>(false)
let currentContracts: any = ref({})
const upConfig = ref([
  {
    label: '备注',
    value: '',
    upKey: 'note',
    props: { type: 'textarea', style: 'width: 610px', rows: 4},
  },
])
const viewContractHandle = (row: any) => {
  currentContracts.value = row
  isShowFile.value = true
}

// 上传文件成功回调
const upFileSuccessHandle = async () => {
  let rep = await labor_contractsFileListApi({id: currentContracts.value.id})
  currentContracts.value.fileList = rep
}
// 删除附件
const delFileHandle = (row: {fileId: string,filename: string}) => {
  ElMessageBox.confirm(
    `是否删除:${row.filename}?`,
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    MI_identify.value = true
    return delete_fileApi({fileId: row.fileId, contractId: currentContracts.value.id})
  }).then(() => {
    MI_identify.value = false
    upFileSuccessHandle()
  }).catch(() => {
    MI_identify.value = false
  })
}

// 下载附件
const contractDownload = (row: {fileId: string}) => {
  ElMessage.success('开始下载')
  isFileListLoad.value = true
  exportHandle(downloadApi, {id: currentContracts.value.id}, {contentType: 'formData'}).then(() => {
    ElMessage.success('下载成功')
  }).finally(() => {
    isFileListLoad.value = false
  })
}

// 预览
const isFileListLoad = ref<boolean>(false)
const realContractUrl = ref<string>('')
const isShowRealContract = ref<boolean>(false)
const previewRealFile = () => {
  
  isFileListLoad.value = true
  return downloadApi({id: currentContracts.value.id}, {contentType: 'formData', responseType: 'blob'}).then((stream: any) => {
    let url = window.URL.createObjectURL(
      new Blob([stream.data], { type: 'application/pdf;charset=UTF-8' })
    )
    realContractUrl.value = url
    isShowRealContract.value = true
  }).finally(() => {
    isFileListLoad.value = false
  })
}

const closeFileListHandle = () => {
  isShowRealContract.value = false
  window.URL.revokeObjectURL(realContractUrl.value)
}

expose({
  searchForm
})

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点此搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              ref_key: "searchForm",
              ref: searchForm
            }, {
            initSearch: true,
            title: true,
            searchConfig: searchConfig.value,
          }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addHandle())),
        type: "primary",
        disabled: _unref(MI_identify)
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (batchUpdataManager())),
        disabled: _unref(MI_identify)
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(ExceptionList, {
        class: "ml-20",
        onSingContract: exceptionAddHandle,
        onRenewHandle: exceptionRenewHandle
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: _cache[2] || (_cache[2] = (rows) => _isRef(selectionRows) //@ts-ignore
 ? selectionRows.value = rows : selectionRows = rows),
      "max-height": _unref(MI_height) - 70 + "px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "50",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "合同编号",
          prop: "no",
          "show-overflow-tooltip": "",
          width: "130",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "合同状态",
          prop: "approvalStatus",
          "show-overflow-tooltip": "",
          width: "130"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(statusMap)[row.approvalStatus]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "合同签订次数",
          prop: "signTimes",
          "show-overflow-tooltip": "",
          width: "120",
          formatter: (row) => _unref(signTimesMap)('map')[row.signTimes]
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "合同类型",
          prop: "category",
          "show-overflow-tooltip": "",
          width: "100",
          formatter: (row) => _unref(categoryMap)('map')[row.category]
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "员工姓名",
          prop: "",
          "show-overflow-tooltip": "",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`${row.employeeName}(${row.employeeAlias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "劳动归属公司",
          prop: "companyName",
          "show-overflow-tooltip": "",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "归属团队",
          prop: "orgName",
          "show-overflow-tooltip": "",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "劳动起",
          prop: "startDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "劳动止",
          prop: "endDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "劳动合同经办人",
          prop: "",
          "show-overflow-tooltip": "",
          width: "135"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`${row.operatorName}(${row.operatorAlias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "合伙人",
          prop: "",
          "show-overflow-tooltip": "",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`${row.leaderName}(${row.leaderAlias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "领导审核日期",
          prop: "leaderAuditorDate",
          "show-overflow-tooltip": "",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "薪酬负责人",
          prop: "",
          "show-overflow-tooltip": "",
          width: "110"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`${row.rewardName}(${row.rewardAlias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "薪酬负责人审核日期",
          prop: "rewardAuditorDate",
          "show-overflow-tooltip": "",
          width: "170"
        }),
        _createVNode(_component_el_table_column, {
          label: "管理者",
          prop: "",
          "show-overflow-tooltip": "",
          width: "110"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`${row.mangerName}(${row.mangerAlias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "基本工资",
          prop: "baseSalary",
          "show-overflow-tooltip": "",
          width: "100",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "职位津贴",
          prop: "jobAllowance",
          "show-overflow-tooltip": "",
          width: "100",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "年度贡献奖",
          prop: "postAllowance",
          "show-overflow-tooltip": "",
          width: "100",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "其他补贴",
          prop: "otherAllowance",
          "show-overflow-tooltip": "",
          width: "100",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "公司补助",
          prop: "companyAllowance",
          "show-overflow-tooltip": "",
          width: "100",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "试用期薪资总额",
          prop: "probationSalary",
          "show-overflow-tooltip": "",
          width: "140",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "转正后薪资总额",
          prop: "regularSalary",
          "show-overflow-tooltip": "",
          width: "140",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "入职日期",
          prop: "hireDate",
          "show-overflow-tooltip": "",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "离职日期",
          prop: "leaveDate",
          "show-overflow-tooltip": "",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "180"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (showPreviewHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (['薪酬负责人审批完成', '附件待上传'].includes(_unref(statusMap)[row.approvalStatus]))
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      onClick: ($event: any) => (directPrintHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (viewContractHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (_unref(statusMap)[row.approvalStatus] === '附件待审核')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 1,
                      onClick: ($event: any) => (checkHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (['未审批', '驳回'].includes(_unref(statusMap)[row.approvalStatus]))
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 2,
                      type: "primary",
                      onClick: ($event: any) => (modifyHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_unref(statusMap)[row.approvalStatus] === '未审批')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 3,
                      type: "danger",
                      onClick: ($event: any) => (delHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      disabled: _unref(MI_identify),
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      "page-sizes": [10, 30, 50, 100, 200, 600],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: isEditContract.value ? '更新合同' : '新增合同',
      modelValue: isShowAddition.value,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((isShowAddition).value = $event)),
      width: "1180px",
      top: "5vh",
      onClose: _cache[34] || (_cache[34] = ($event: any) => (createdEle.value.resetFields()))
    }, {
      footer: _withCtx(() => [
        (!isEditContract.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (showAddPreview()))
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isEditContract.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              onClick: _cache[32] || (_cache[32] = ($event: any) => (submitEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, { "max-height": "70vh" }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_form, {
              model: _unref(createObj),
              "label-width": "90px",
              inline: true,
              ref_key: "createdEle",
              ref: createdEle,
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "员工:",
                  prop: "userId",
                  rules: [{required: true, message: '请选择员工', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(createObj).userId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(createObj).userId) = $event)),
                      placeholder: "请选择员工",
                      filterable: "",
                      clearable: "",
                      onChange: employeeChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userList), (user) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: user.userId,
                            label: user.label,
                            value: user.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "编号:",
                  prop: "no",
                  rules: [{required: true, message: '请输入合同编号', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(createObj).no,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(createObj).no) = $event)),
                      placeholder: "请输入合同编号",
                      clearable: "",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司:",
                  prop: "companyId",
                  rules: [{required: true, message: '请选择公司', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(createObj).companyId,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(createObj).companyId) = $event)),
                      placeholder: "请选择公司",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: comp.name,
                                  value: comp.id,
                                  key: comp.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "orgId",
                  rules: [{required: true, message: '请选择团队', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(createObj).orgId,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(createObj).orgId) = $event)),
                      placeholder: "请选择团队",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orgList), (org) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: org.name,
                            value: org.id,
                            key: org.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "合同状态:",
                  prop: "category",
                  rules: [{required: true, message: '请选择合同状态', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(createObj).category,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(createObj).category) = $event)),
                      placeholder: "请选择合同状态",
                      filterable: "",
                      clearable: "",
                      onChange: categoryChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoryMap)(), (status) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: status.label,
                            value: status.id,
                            key: status.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "签订次数:",
                  prop: "signTimes",
                  rules: [{required: true, message: '请选择签订次数', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(createObj).signTimes,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(createObj).signTimes) = $event)),
                      placeholder: "请选择签订次数",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(signTimesMap)(), (time) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: time.label,
                            value: time.id,
                            key: time.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "开始日期:",
                  prop: "startDate",
                  rules: [{required: true, message: '请选择开始日期', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(createObj).startDate,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(createObj).startDate) = $event)),
                      "value-format": "YYYY-MM-DD",
                      type: "date",
                      clearable: "",
                      class: "form-input",
                      placeholder: "请选择开始日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "结束日期:",
                  prop: "endDate",
                  rules: [{required: _unref(createObj).signTimes !== 'Forever', message: '请选择结束日期', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(createObj).endDate,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(createObj).endDate) = $event)),
                      "value-format": "YYYY-MM-DD",
                      type: "date",
                      clearable: "",
                      class: "form-input",
                      placeholder: "请选择结束日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_el_form_item, {
                  label: "试用时长(月):",
                  prop: "probationTime",
                  rules: [{required: true, message: '请输入试用时长', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(createObj).probationTime,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(createObj).probationTime) = $event)),
                      precision: 0,
                      controls: false,
                      min: 0,
                      max: 100,
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "合伙人:",
                  prop: "leaderId",
                  rules: [{required: true, message: '请选择合伙人', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(createObj).leaderId,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(createObj).leaderId) = $event)),
                      placeholder: "请选择合伙人",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leadersOption.value, (user) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: user.userId,
                            label: user.label,
                            value: user.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "薪酬负责人:",
                  prop: "rewardId",
                  rules: [{required: true, message: '请选择薪酬负责人', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(createObj).rewardId,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(createObj).rewardId) = $event)),
                      placeholder: "请选择薪酬负责人",
                      filterable: "",
                      clearable: "",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userList), (user) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: user.userId,
                            label: user.label,
                            value: user.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "劳动合同经办人:",
                  prop: "operator",
                  rules: [{required: true, message: '请选择劳动合同经办人', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(createObj).operator,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(createObj).operator) = $event)),
                      placeholder: "请选择劳动合同经办人",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userList), (user) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: user.userId,
                            label: user.label,
                            value: user.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "基础薪酬:",
                  prop: "baseSalary",
                  rules: [{required: true, message: '请输入基础薪酬', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(createObj).baseSalary,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(createObj).baseSalary) = $event)),
                      precision: 2,
                      controls: false,
                      min: 0,
                      class: "form-input",
                      onChange: computedSalaryTotal
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "职位津贴:",
                  prop: "jobAllowance",
                  rules: [{required: true, message: '请输入职位津贴', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(createObj).jobAllowance,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(createObj).jobAllowance) = $event)),
                      precision: 2,
                      controls: false,
                      min: 0,
                      class: "form-input",
                      onChange: computedSalaryTotal
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_unref(createObj).signTimes === 'First')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "试用期年度贡献奖:",
                      prop: "probationPostAllowance",
                      rules: [{required: true, message: '请输入试用期年度贡献奖', trigger: 'change'}]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _unref(createObj).probationPostAllowance,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(createObj).probationPostAllowance) = $event)),
                          precision: 2,
                          controls: false,
                          min: 0,
                          class: "form-input",
                          onChange: computedSalaryTotal,
                          disabled: _unref(createObj).signTimes !== 'First'
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "转正年度贡献奖:",
                  prop: "postAllowance",
                  rules: [{required: true, message: '请输入转正年度贡献奖', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(createObj).postAllowance,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(createObj).postAllowance) = $event)),
                      precision: 2,
                      controls: false,
                      min: 0,
                      class: "form-input",
                      onChange: computedSalaryTotal
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "其他补贴:",
                  prop: "otherAllowance",
                  rules: [{required: true, message: '请输入其他补贴', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(createObj).otherAllowance,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(createObj).otherAllowance) = $event)),
                      precision: 2,
                      controls: false,
                      min: 0,
                      class: "form-input",
                      onChange: computedSalaryTotal
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司补助:",
                  prop: "companyAllowance",
                  rules: [{required: true, message: '请输入公司补助', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(createObj).companyAllowance,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(createObj).companyAllowance) = $event)),
                      precision: 2,
                      controls: false,
                      min: 0,
                      class: "form-input",
                      onChange: computedSalaryTotal
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_unref(createObj).signTimes === 'First')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "试用期绩效奖金:",
                      prop: "probationPerformanceBonus",
                      rules: [{required: true, message: '请输入试用期绩效奖金', trigger: 'change'}]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _unref(createObj).probationPerformanceBonus,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(createObj).probationPerformanceBonus) = $event)),
                          precision: 2,
                          controls: false,
                          min: 0,
                          class: "form-input",
                          onChange: computedSalaryTotal,
                          disabled: _unref(createObj).signTimes !== 'First'
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "转正绩效奖金:",
                  prop: "performanceBonus",
                  rules: [{required: true, message: '请输入转正绩效奖金', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(createObj).performanceBonus,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(createObj).performanceBonus) = $event)),
                      precision: 2,
                      controls: false,
                      min: 0,
                      class: "form-input",
                      onChange: computedSalaryTotal
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "全勤奖金:",
                  prop: "perfectAttendanceAward",
                  rules: [{required: true, message: '请输入全勤奖金', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(createObj).perfectAttendanceAward,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(createObj).perfectAttendanceAward) = $event)),
                      precision: 2,
                      controls: false,
                      min: 0,
                      class: "form-input",
                      onChange: computedSalaryTotal
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_unref(createObj).signTimes === 'First')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "试用期工资总额:",
                      prop: "probationSalary",
                      rules: [{required: true, message: '请输入试用期工资总额', trigger: 'change'}]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _unref(createObj).probationSalary,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(createObj).probationSalary) = $event)),
                          precision: 2,
                          controls: false,
                          min: 0,
                          class: "form-input",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "转正后工资总额:",
                  prop: "regularSalary",
                  rules: [{required: true, message: '请输入转正后工资总额', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(createObj).regularSalary,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(createObj).regularSalary) = $event)),
                      precision: 2,
                      controls: false,
                      min: 0,
                      class: "form-input",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "工作地点:",
                  prop: "officeSpace",
                  rules: [{required: true, message: '请选择工作地点', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(createObj).officeSpace,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(createObj).officeSpace) = $event)),
                      "allow-create": "",
                      placeholder: "请选择工作地点",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(officeList), (location) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: location.address,
                            label: location.address,
                            value: location.address
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_10,
                _createVNode(_component_el_form_item, {
                  label: "备注:",
                  prop: "note"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      style: {"width":"472px"},
                      modelValue: _unref(createObj).note,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(createObj).note) = $event)),
                      maxlength: 300,
                      type: "textarea",
                      placeholder: "请输入备注",
                      clearable: "",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "其他约定(将直接展示在合同文件的备注区域):",
                  prop: "otherAgreement"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      style: {"width":"472px"},
                      modelValue: _unref(createObj).otherAgreement,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(createObj).otherAgreement) = $event)),
                      maxlength: 3000,
                      type: "textarea",
                      placeholder: "请输入其他约定",
                      clearable: "",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])), [
              [_directive_loading, isAddPanelLoad.value]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "管理人",
      modelValue: isShowUpdata.value,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((isShowUpdata).value = $event)),
      draggable: "",
      width: "500px"
    }, {
      default: _withCtx(() => [
        (isShowUpdata.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: updataConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "附件列表",
      modelValue: isShowFile.value,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((isShowFile).value = $event)),
      width: "1100px",
      onClose: _cache[38] || (_cache[38] = ($event: any) => (closeFileListHandle()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TheUpBtn, {
          upText: '上传附件',
          upFetch: _unref(uploadApi),
          upConfig: upConfig.value,
          upParams: {contractId: _unref(currentContracts).id},
          onUpSuccess: upFileSuccessHandle,
          showBtn: true
        }, null, 8, ["upFetch", "upConfig", "upParams"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _unref(currentContracts).fileList,
          class: "mt-10 mb-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "文件",
              prop: "filename",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "备注",
              prop: "note",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "上传时间",
              prop: "uploadAt",
              formatter: _unref(formatTime),
              "show-overflow-tooltip": ""
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, {
                      onClick: ($event: any) => (previewRealFile(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (contractDownload(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      type: "danger",
                      onClick: ($event: any) => (delFileHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, isFileListLoad.value]
        ]),
        (isShowRealContract.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _cache[36] || (_cache[36] = ($event: any) => (closeFileListHandle())),
              class: "mb-10"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isShowRealContract.value)
          ? (_openBlock(), _createElementBlock("embed", {
              key: 1,
              src: realContractUrl.value,
              width: "100%",
              height: "620px"
            }, null, 8, _hoisted_17))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "确认预览",
      modelValue: isShowPreviewTemplate.value,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((isShowPreviewTemplate).value = $event)),
      width: "1100px",
      draggable: "",
      top: "100px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[39] || (_cache[39] = ($event: any) => (submitAddContract())),
          loading: addBtnLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (isShowPreviewTemplate.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (_unref(previewContractObj).category === 'FullTime')
                ? (_openBlock(), _createBlock(ContractTemplate, {
                    key: 0,
                    ref_key: "templateEle",
                    ref: templateEle,
                    contractInfoObj: _unref(previewContractObj)
                  }, null, 8, ["contractInfoObj"]))
                : _createCommentVNode("", true),
              (_unref(previewContractObj).category === 'PartTime')
                ? (_openBlock(), _createBlock(ServiceTemplate, {
                    key: 1,
                    ref_key: "templateEle",
                    ref: templateEle,
                    contractInfoObj: _unref(previewContractObj)
                  }, null, 8, ["contractInfoObj"]))
                : _createCommentVNode("", true),
              (_unref(previewContractObj).category === 'Internship')
                ? (_openBlock(), _createBlock(InternshipTemplate, {
                    key: 2,
                    ref_key: "templateEle",
                    ref: templateEle,
                    contractInfoObj: _unref(previewContractObj)
                  }, null, 8, ["contractInfoObj"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "预览",
      modelValue: isShowPrint.value,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((isShowPrint).value = $event)),
      width: "1100px",
      draggable: "",
      top: "100px"
    }, {
      default: _withCtx(() => [
        (isShowPrint.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[41] || (_cache[41] = ($event: any) => (printHandle()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                })
              ]),
              (_unref(printPreviewObj).category === 'FullTime')
                ? (_openBlock(), _createBlock(ContractTemplate, {
                    key: 0,
                    ref: "PreviewTemplateEle",
                    contractInfoObj: _unref(printPreviewObj)
                  }, null, 8, ["contractInfoObj"]))
                : _createCommentVNode("", true),
              (_unref(printPreviewObj).category === 'PartTime')
                ? (_openBlock(), _createBlock(ServiceTemplate, {
                    key: 1,
                    ref: "PreviewTemplateEle",
                    contractInfoObj: _unref(printPreviewObj)
                  }, null, 8, ["contractInfoObj"]))
                : _createCommentVNode("", true),
              (_unref(printPreviewObj).category === 'Internship')
                ? (_openBlock(), _createBlock(InternshipTemplate, {
                    key: 2,
                    ref: "PreviewTemplateEle",
                    contractInfoObj: _unref(printPreviewObj)
                  }, null, 8, ["contractInfoObj"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "校对",
      modelValue: _unref(isShowCheck),
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_isRef(isShowCheck) ? (isShowCheck).value = $event : isShowCheck = $event)),
      fullscreen: "",
      onClose: _cache[46] || (_cache[46] = ($event: any) => (closeFileListHandle()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[43] || (_cache[43] = ($event: any) => (_isRef(isShowCheck) //@ts-ignore
 ? isShowCheck.value = false : isShowCheck = false)),
          disabled: btnLoad.value || isFileListLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[44] || (_cache[44] = ($event: any) => (submitConfirm())),
          loading: btnLoad.value,
          disabled: isFileListLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                (isShowRealContract.value)
                  ? (_openBlock(), _createElementBlock("embed", {
                      key: 0,
                      src: realContractUrl.value,
                      width: "100%",
                      height: checkHeight
                    }, null, 8, _hoisted_23))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                (_unref(isShowCheck))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "contractContent",
                      style: _normalizeStyle({ padding: '0 40px', overflow: 'scroll', height: checkHeight + 'px' })
                    }, [
                      (_unref(checkPreviewObj).category === 'FullTime')
                        ? (_openBlock(), _createBlock(ContractTemplate, {
                            key: 0,
                            ref: "checkTemplateEle",
                            contractInfoObj: _unref(checkPreviewObj)
                          }, null, 8, ["contractInfoObj"]))
                        : _createCommentVNode("", true),
                      (_unref(checkPreviewObj).category === 'PartTime')
                        ? (_openBlock(), _createBlock(ServiceTemplate, {
                            key: 1,
                            ref: "checkTemplateEle",
                            contractInfoObj: _unref(checkPreviewObj)
                          }, null, 8, ["contractInfoObj"]))
                        : _createCommentVNode("", true),
                      (_unref(checkPreviewObj).category === 'Internship')
                        ? (_openBlock(), _createBlock(InternshipTemplate, {
                            key: 2,
                            ref: "checkTemplateEle",
                            contractInfoObj: _unref(checkPreviewObj)
                          }, null, 8, ["contractInfoObj"]))
                        : _createCommentVNode("", true)
                    ], 4))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, isFileListLoad.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})